import { Nullable } from "typescript-nullable";
import { useAppSelector } from "../../Redux/Hooks/hooks.redux";
import { User } from "../../Types/User";

export function useUser(): Nullable<User>  {
    const {appAuthState} = useAppSelector((state)=>(state.appState))
    return appAuthState.user
}

